import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
import { styled } from '@mui/system';
import ClientDataActions from './ClientDataActions';
import TaxAuthorityValidityCell from './TaxAuthorityValidityCell';
import WithholdingTaxValidityCell from './WithholdingTaxValidityCell';

const BodyRow = styled(TableRow)({
  transition: 'background-color 0.15s ease',
});

const Cell = styled(TableCell)({
  textAlign: 'center',
  fontVariantNumeric: 'tabular-nums',
  fontSize: 'var(--xtram-panel-cell, 12px) !important',
});

const ClientDataTableRow = ({
  client,
  headerStyle: _headerStyle,
  subAccountants,
  isManageOnly = false,
  ...rest
}) => (
  <BodyRow>
    <Cell>
      <ClientDataActions {...rest} client={client} />
    </Cell>
    <Cell>{client.caseId}</Cell>
    <Cell>{client.name}</Cell>
    <Cell>{client.clientId}</Cell>
    <Cell>{client.phoneNumber}</Cell>
    <Cell>{client.taxAssessor}</Cell>
    <Cell>
      {subAccountants.find((option) => option.value === client.subAccountantId)?.label}
    </Cell>
    <Cell>{client.deductionsCase || '-'}</Cell>
    <Cell>{client.economicBusinessBranch || '-'}</Cell>
    {!isManageOnly && (
      <>
        <Cell>
          <WithholdingTaxValidityCell client={client} />
        </Cell>
        <Cell>
          <TaxAuthorityValidityCell {...rest} client={client} />
        </Cell>
      </>
    )}
  </BodyRow>
);

ClientDataTableRow.propTypes = {
  client: PropTypes.object.isRequired,
  headerStyle: PropTypes.object,
  subAccountants: PropTypes.array.isRequired,
  editIcon: PropTypes.string.isRequired,
  deleteIcon: PropTypes.string.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
  permissionsState: PropTypes.object.isRequired,
  userTypeContext: PropTypes.any,
  Constants: PropTypes.object.isRequired,
  tokenDaysRemaining: PropTypes.number,
  TaxAuthorityService: PropTypes.object.isRequired,
  token: PropTypes.string,
  handleTaxAuthorityAuth: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  refreshTokenValidity: PropTypes.func,
  isManageOnly: PropTypes.bool,
};

export default ClientDataTableRow;
